import * as React from 'react';

export enum SelectableTypes {
  RADIO = 'radio',
  CHECKBOX = 'checkbox'
}

export type SelectableColors = 'green';

export interface SelectableProps<T = void> {
  id: string;
  selectableType?: SelectableTypes;
  onChange?: (e: React.SyntheticEvent) => T | Promise<T>;
  onClick?: (e: React.SyntheticEvent) => T | Promise<T>;
  analyticsTag?: string;
}
